import { render, staticRenderFns } from "./StrategyFlow.vue?vue&type=template&id=0fa2c408&"
import script from "./StrategyFlow.vue?vue&type=script&lang=ts&"
export * from "./StrategyFlow.vue?vue&type=script&lang=ts&"
import style0 from "./StrategyFlow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports